export const colorMap: { [key: string]: string | undefined } = {
  '#366ce1':
    'invert(34%) sepia(93%) saturate(1832%) hue-rotate(211deg) brightness(91%) contrast(93%)',
  '#55c0eb':
    'invert(70%) sepia(81%) saturate(1043%) hue-rotate(166deg) brightness(96%) contrast(91%)',
  '#ea7723':
    'invert(74%) sepia(44%) saturate(6641%) hue-rotate(346deg) brightness(95%) contrast(93%)',
  '#fac90f':
    'invert(90%) sepia(12%) saturate(6487%) hue-rotate(351deg) brightness(101%) contrast(96%)',
  '#000': 'black',
  '#333': 'invert(15%) sepia(0%) saturate(5903%) hue-rotate(107deg) brightness(93%) contrast(90%',
  '#308f5a':
    'invert(46%) sepia(22%) saturate(1043%) hue-rotate(94deg) brightness(96%) contrast(95%)',
  '#25c8a3':
    'invert(62%) sepia(98%) saturate(331%) hue-rotate(115deg) brightness(87%) contrast(93%)',
  '#c8a10c':
    'invert(80%) sepia(57%) saturate(3523%) hue-rotate(7deg) brightness(89%) contrast(91%)',
  '#bf7b7b':
    'invert(92%) sepia(89%) saturate(1854%) hue-rotate(292deg) brightness(75%) contrast(101%)',
  '#ba184f':
    'invert(17%) sepia(71%) saturate(3292%) hue-rotate(324deg) brightness(92%) contrast(98%)',
  '#ed4b82':
    'invert(48%) sepia(21%) saturate(3970%) hue-rotate(309deg) brightness(92%) contrast(102%)',
}

export const colors = Object.keys(colorMap)
